import axios from 'axios';

import { type Search } from '../../shared/types/search';
import { type SearchResult } from '../../shared/types/searchResult';

export const fetchProducts = async (search: Search): Promise<SearchResult> => {
    try {
        const result = await axios.post<SearchResult>('/api/products', {
            search,
        });

        return result.data;
    } catch {
        // Note: Client-side logging is limited, but we still want to handle errors gracefully
        // The server-side searchProductsHandler will log the actual error with proper logger

        // Return empty result to prevent fragment failure
        return {
            items: [],
            totalItemCount: 0,
            search,
        };
    }
};
